import { render, staticRenderFns } from "./BoardDetailsPage.vue?vue&type=template&id=628475f5&scoped=true&"
import script from "./BoardDetailsPage.vue?vue&type=script&lang=js&"
export * from "./BoardDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./BoardDetailsPage.vue?vue&type=style&index=0&id=628475f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628475f5",
  null
  
)

export default component.exports